export default __webpack_public_path__ + "static/media/icon_LAS-hover.eda82c2d.svg";